import { useContext, useMemo, useState } from "react";
import { Box, Button, Card, Stack, Typography } from "@mui/material";
import { Icon } from "@iconify/react";
import downloadFill from "@iconify/icons-eva/download-fill";
import refreshFill from "@iconify/icons-eva/refresh-fill";
import { BaseTable } from "src/components/BaseTable/BaseTable";
import { useSelectedTeam } from "src/hooks/useSelectedTeam";
import { useInvoiceExports } from "./invoiceExport.hook";
import { invoiceExportColumns } from "./InvoiceExportDownloadTab.constants";
import InvoiceExportRequestDialog from "./InvoiceExportRequestDialog";
import { Context } from "src/context";

export const InvoiceExportDownloadTab = ({ isReadOnly }) => {
  const { teamId } = useSelectedTeam();
  const { timezone } = useContext(Context);
  const [dialogOpen, setDialogOpen] = useState(false);
  const { rows, isFetching, refetch } = useInvoiceExports({ teamId });

  const columns = useMemo(
    () => invoiceExportColumns(timezone.timezone?.value),
    [timezone.timezone?.value]
  );

  return (
    <Card sx={{ p: 2 }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "stretch", sm: "center" }}
        spacing={1.5}
        sx={{ mb: 2 }}
      >
        <Box>
          <Typography variant="subtitle1">Invoice downloads</Typography>
          <Typography variant="body2" color="text.secondary">
            Request all invoices for a period as a single zip file.
          </Typography>
        </Box>
        <Stack direction="row" spacing={1}>
          <Button
            size="small"
            color="inherit"
            onClick={() => refetch()}
            startIcon={<Icon icon={refreshFill} />}
          >
            Refresh
          </Button>
          {!isReadOnly && (
            <Button
              variant="contained"
              size="small"
              onClick={() => setDialogOpen(true)}
              startIcon={<Icon icon={downloadFill} />}
            >
              Request download
            </Button>
          )}
        </Stack>
      </Stack>

      <BaseTable
        rows={rows}
        columns={columns}
        loading={isFetching}
        pageSize={10}
        isReadOnly={false}
        getRowId={(row) => row.id}
        getRowHeight={() => "auto"}
      />

      <InvoiceExportRequestDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </Card>
  );
};

export default InvoiceExportDownloadTab;
